module.exports = __webpack_public_path__ + "static/media/aman.74839a56.jpeg";